import { Col, Row, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';
import LogEventServiceCamera from '../../../../components/LogEventSeriveCamera';

const ConsoleTab = ({
  keyTable,
  devicesActive,
  service,
  expKeys,
  setExpKeys,
  setKeyTable,
  setCheckUpdatePerDevice,
  formExpand,
  initialPerDevice,
  handleTableChangeActive,
  isLoadActiveLicense,
}) => {
  const { t } = useTranslation();

  const dataSource =
    devicesActive?.data?.map((device) => ({
      ...device,
      key: device.serial,
    })) ?? [];

  return (
    <Row style={{ marginLeft: '0px' }}>
      <Col span={24}>
        <Table
          key={keyTable}
          dataSource={dataSource}
          expandable={{
            expandedRowRender: (record) => (
              <LogEventServiceCamera
                dataDevice={record}
                baseUrl={service?.baseUrl}
                serviceId={service?.id}
              />
            ),
          }}
          expandedRowKeys={expKeys}
          onExpand={(check, record) => {
            setExpKeys(check ? [record?.serial] : []);
            setKeyTable(Math.random());
            setCheckUpdatePerDevice(true);
            const dataConfigurationTemp =
              record?.service?.configuration &&
              JSON.parse(record?.service?.configuration);
            formExpand.setFieldsValue(
              dataConfigurationTemp &&
                Object.keys(dataConfigurationTemp).length > 0
                ? dataConfigurationTemp
                : initialPerDevice ?? {}
            );
          }}
          pagination={devicesActive && devicesActive.pagination}
          loading={devicesActive && devicesActive.loading}
          onChange={handleTableChangeActive}
          columns={[
            {
              title: t('Name'),
              dataIndex: 'name',
              key: 'name_device',
              sorter: (a, b) => a.name.localeCompare(b.name),
            },
            {
              title: t('State'),
              key: 'log_action',
              width: 200,
              render: (device) =>
                isLoadActiveLicense.some(
                  (serial) => serial === device.serial
                ) ? (
                  <Tag
                    style={{ width: 120, textAlign: 'center' }}
                    color={colorsDark.$warning}
                  >
                    {t('Activating')}
                  </Tag>
                ) : device.service ? (
                  <Tag
                    style={{ width: 120, textAlign: 'center' }}
                    color={colorsDark.$online}
                  >
                    {t('Activated')}
                  </Tag>
                ) : (
                  <Tag
                    style={{ width: 120, textAlign: 'center' }}
                    color={colorsDark.$offline}
                  >
                    {t('Not activated')}
                  </Tag>
                ),
            },
            {
              title: t('Active date'),
              key: 'log_activatedAt',
              dataIndex: 'service',
              sorter: (a, b) =>
                a.service?.activatedAt?.localeCompare(
                  b.service?.activatedAt
                ),
              render: (serviceRecord) =>
                serviceRecord?.activatedAt
                  ? moment(serviceRecord.activatedAt).format('DD-MM-YYYY')
                  : '',
            },
            {
              title: t('License Code'),
              key: 'service_license_code_device',
              dataIndex: 'service',
              render: (serviceRecord) =>
                serviceRecord?.licenseCode ? serviceRecord?.licenseCode : '',
            },
            {
              title: t('License Info'),
              key: 'service_license_info_device',
              dataIndex: 'service',
              render: (serviceRecord) =>
                serviceRecord?.licenseInfo ? serviceRecord?.licenseInfo : '',
            },
          ]}
        />
      </Col>
    </Row>
  );
};

export default ConsoleTab;
